import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { setMainSessionId } from 'store/session/actions';

import { useDispatch } from 'hooks/store';

import { uuidv4 } from 'helpers/utils';

import useMainSessionTracker from './useMainSessionTracker';
import usePlanSessionTracker from './usePlanSessionTracker';

const useSessionTrackers = () => {
    const location = useLocation();
    const isFirstRender = useRef(true);

    const dispatch = useDispatch();

    const { endMainSessionHandler, startMainSessionHandler } = useMainSessionTracker();

    const { endPlanSessionHandler, startPlanSessionHandler, onPlanRouteChange } = usePlanSessionTracker();

    useEffect(() => {
        const onSessionStart = () => {
            dispatch(setMainSessionId(uuidv4()));

            startMainSessionHandler();
            startPlanSessionHandler();
        };

        const onSessionEnd = () => {
            endMainSessionHandler();
            endPlanSessionHandler();

            dispatch(setMainSessionId(''));
        };

        const onVisibilityChange = () => {
            document.visibilityState === 'hidden' ? onSessionEnd() : onSessionStart();
        };

        window.addEventListener('visibilitychange', onVisibilityChange);

        return () => {
            window.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, [endMainSessionHandler, endPlanSessionHandler, startMainSessionHandler, startPlanSessionHandler, dispatch]);

    useEffect(() => {
        if (!isFirstRender.current) {
            onPlanRouteChange();
        } else {
            isFirstRender.current = false;
        }
    }, [location.pathname, onPlanRouteChange]);
};

export default useSessionTrackers;
